/** @format */

import { Component, input, output } from '@angular/core';
import {
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService,
	homefieldIconChevronLeft,
	homefieldIconChevronRight
} from '@dsg-tech/homefield-angular-icons';

import { LongPressDirective } from './long-press.directive';
import { NgClass } from '@angular/common';

@Component({
	selector: 'shared-components-carousel-button',
	imports: [NgClass, HomefieldIconLibraryModule, LongPressDirective],
	templateUrl: './carousel-button.component.html',
	styleUrl: './carousel-button.component.scss'
})
export class CarouselButtonComponent {
	readonly label = input('');
	readonly previous = input(false);
	readonly showLeftArrow = input(false);
	readonly showRightArrow = input(false);
	readonly ariaLabel = input(null);

	readonly clickEvent = output<boolean>();

	constructor(private readonly homefieldIconsLibraryService: HomefieldIconsLibraryService) {
		this.homefieldIconsLibraryService.registerIcons([
			homefieldIconChevronLeft,
			homefieldIconChevronRight
		]);
	}

	onClick(): void {
		this.clickEvent.emit(this.previous());
	}
}
